import gql from "graphql-tag"

const DELETE_CUSTOM_GIFT_CARD_CONFIG = gql`
  mutation deleteBSGGiftCardConfig($id: ID!) {
    deleteBSGGiftCardConfig(id: $id) {
      status
    }
  }
`

export default DELETE_CUSTOM_GIFT_CARD_CONFIG
